import { Link, useLocation } from 'react-router'
import { EntityAvatar } from '@/components/ui/entity-avatar'
import { Dash } from '../list/commonCells'
import type { OrganisationRow } from '../query/types'

/** The name with its first domain under it; the list's search, sort and page travel with the link as the way back. */
export function OrganisationNameCell({ row }: { row: OrganisationRow }) {
  const location = useLocation()
  return (
    // The cap makes `truncate` work: a table cell is as wide as its text otherwise, and
    // a long name (a foundation's full name) would push the other columns out of view.
    <div className="flex max-w-[24rem] items-center gap-2">
      <EntityAvatar kind="company" name={row.name} size="md" />
      <div className="flex min-w-0 flex-col">
        <Link
          to={`/relaties/organisaties/${row.id}`}
          state={{ from: location.search }}
          title={row.name}
          className="truncate font-medium underline-offset-2 hover:underline"
        >
          {row.name}
        </Link>
        {row.domains[0] ? <span className="truncate text-xs text-muted-foreground">{row.domains[0]}</span> : null}
      </div>
      {row.status === 'inactief' ? <span className="text-xs text-muted-foreground">(gearchiveerd)</span> : null}
    </div>
  )
}

export function ContactsCountCell({ row }: { row: OrganisationRow }) {
  return (
    <span className="flex items-center gap-1.5">
      <span className="flex -space-x-1.5">
        {row.contacts_preview.map((person) => (
          <EntityAvatar key={person.person_id} kind="person" name={person.full_name} size="sm" className="ring-2 ring-card" />
        ))}
      </span>
      <span className="tabular-nums text-muted-foreground">{row.contacts_count}</span>
    </span>
  )
}

/** The website without its scheme, cut off when it is long; the whole address is the tooltip. */
export function WebsiteCell({ website }: { website: string | null }) {
  if (!website) return <Dash />
  return (
    <span className="block max-w-56 truncate text-muted-foreground" title={website}>
      {website.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')}
    </span>
  )
}
